const texts = {
  title: 'Days',
  addNewDay: 'Add New Day',
  repeatDays: 'Repeat Days',
  day: 'Day',
  noOptionText: 'No workout found...',
  estDuration: 'Est: {minutes} mins',
  equipment: 'Equipment: {equipment}',
  none: 'None',
  moreEquipment: 'More...',
  textFieldLabel: 'Select Workout',
  draftWorkout: '{draftReason}, and therefore is not eligible for assignment',
  deleteConfirmMsg: 'Are you sure you want to remove the Day {workoutDate} workout?',
  viewWorkout: 'View',
  editWorkout: 'Edit',
  resetWorkout: 'Reset',
};

export default texts;
